/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_ExpertrealityInputs */

const cs_enum_expertreality = /** @type {(inputs: Enum_ExpertrealityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ExpertReality`)
};

const en_enum_expertreality = /** @type {(inputs: Enum_ExpertrealityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ExpertReality`)
};

/**
* | output |
* | --- |
* | "ExpertReality" |
*
* @param {Enum_ExpertrealityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_expertreality = /** @type {((inputs?: Enum_ExpertrealityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_ExpertrealityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_expertreality(inputs)
	return cs_enum_expertreality(inputs)
});